import { render } from "./icon-smile-bag.vue?vue&type=template&id=0ef2f052"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__